<div class="app-layout">
  <ftr-header [logoData]="logoData" />

  <main>
    <ng-content />
  </main>

  <ftr-footer />
</div>
